import {
  FORUM_DATA_CATEGORIES_MANAGER_ID,
  TEMPLATE_CATEGORY_ID,
} from '../constants/categories-manager';
import { omit, isString } from 'lodash';
import { COVER_TYPE_COLOR } from '../constants/cover-types';

export const OMIT_FIELDS = [
  '_id',
  'instanceId',
  'totalPosts',
  'totalViews',
  'isSubscribed',
  'slug',
  'slugs',
];

export const omitProhibitedUpdateFields = category => omit(category, OMIT_FIELDS);

export const createCategoryTemplate = ({ description, label, rank }) => ({
  coverType: COVER_TYPE_COLOR,
  description,
  label,
  headerTitle: label,
  rank,
  totalPosts: 0,
  totalViews: 0,
  _id: TEMPLATE_CATEGORY_ID,
});

export const isForumData = categoryId => categoryId === FORUM_DATA_CATEGORIES_MANAGER_ID;

// older categories won't have headerTitle property so we take label
export const getHeaderTitle = category =>
  isString(category.headerTitle) ? category.headerTitle : category.label;
